import {
  deletePaymentRequestPassiveApproval,
  editPaymentRequestPassiveComitee,
  getPaymentRequestPassiveMissingApprovals,
  makeApprovalPaymentRequestPassive,
  makeRejectPaymentRequestPassive,
} from 'lib/api/paymentRequestPassives';
import { PaymentRequestPassive } from 'lib/types/models';
import Committee from 'pages/Finance/Components/Financing/common/Comittee';
import { CommitteeService } from 'pages/Finance/Components/Financing/common/Comittee/types';
import React from 'react';

const createCreditLineCommitteeService = (
  request: PaymentRequestPassive,
  canEdit: boolean,
  refreshRequest?: () => Promise<void>,
): CommitteeService => ({
  requestId: request.id,
  canEdit: canEdit,
  isRejected: request.status === 'Rechazada',
  isActive: request.status === 'Completada',
  getMissingApprovals: async (dispatch, requestId) => {
    const response = await getPaymentRequestPassiveMissingApprovals(dispatch, {
      id: requestId,
    });
    return response;
  },
  approve: async (dispatch, requestId, data) => {
    await makeApprovalPaymentRequestPassive(dispatch, {
      id: requestId,
      message: data.reason,
      roleId: data.roleId,
    });
    if (refreshRequest) await refreshRequest();
  },
  reject: async (dispatch, requestId, data) => {
    await makeRejectPaymentRequestPassive(dispatch, {
      id: requestId,
      message: data.reason,
      roleId: data.roleId,
    });
    if (refreshRequest) await refreshRequest();
  },
  updateCommittee: async (dispatch, requestId, data) => {
    await editPaymentRequestPassiveComitee(dispatch, requestId, {
      comiteeId: data.comiteeId,
    });
    if (refreshRequest) await refreshRequest();
  },
  deleteApproval: async (dispatch, requestId, approvalId) => {
    await deletePaymentRequestPassiveApproval(dispatch, requestId, approvalId);
    if (refreshRequest) await refreshRequest();
  },
});

const PaymentRequestApprovals = ({
  request,
  refreshRequest,
}: {
  request: PaymentRequestPassive;
  refreshRequest: () => Promise<void>;
}) => {
  const canEdit =
    request.status !== 'Completada' && request.status !== 'Rechazada';

  const committeeService = createCreditLineCommitteeService(
    request,
    canEdit,
    refreshRequest,
  );
  return <Committee committeeService={committeeService} />;
};

export default PaymentRequestApprovals;
